import script from "./udfField.vue?vue&type=script&setup=true&lang=js"
export * from "./udfField.vue?vue&type=script&setup=true&lang=js"

import "./udfField.vue?vue&type=style&index=0&id=05ce8cda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ce8cda"]])

export default __exports__